import { gql } from "@stadium/services/apollo-client";
import { PRODUCT_SEARCH_BASICS_DETAILS } from "@graphql/fragments/product/product-search-basic-details";

export const fetchBaseProductsList = gql`
  query ProductsList(
    $storeId: Int
    $countryCode: String
    $countryCodes: [String!]
    $taxonIds: [Int!]
    $budget: Int
    $dietaryRestrictionIds: [Int!]
    $page: Int
    $brandId: Int
    $priceKeys: [String!]
    $color: [String!]
    $size: [String!]
    $perPage: Int
    $sortBy: String
    $searchQuery: String
    $productId: Int
    $productionDays: [Int!]
    $shippedFromStadium: Boolean
    $skipAggregations: Boolean
    $skipWarehouse: Boolean
    $storeUpcharge: Float
    $withSwag: Boolean
    $designedStoreIds: [Int!]
    $menuId: Int
    $preFilterProductIds: [Int!]
    $brandIds: [Int!]
    $storeUpdatedAt: String
    $excludeOnlyBundleComponentItems: Boolean
    $limit: Int
    $globalZone: Boolean
    $withOutOfStock: Boolean
    $showVariantsAsProducts: Boolean
    $noMinQuantity: Boolean
    $bulkProducts: Boolean
    $ecoFriendly: Boolean
    $bulkAvailable: Boolean
    $menuItemId: Int
    $intent: String
    $type: String
    $hasTierPricing: Boolean
    $sustainable: Boolean
    $optimizedSearch: Boolean
    $coreOnDemand: Boolean
    $additionalOnDemand: Boolean
    $printTypes: [String!]
    $excludeByoProducts: Boolean
    $excludeTierPricing: Boolean
    $currentStoreId: Int
    $includeProductVariants: Boolean = false
    $includeNonColorProducts: Boolean = false
    $designer: Boolean
    $menuIdentifier: String
  ) @api(name: "search") {
    baseSearch(
      storeId: $storeId
      countryCode: $countryCode
      countryCodes: $countryCodes
      taxonIds: $taxonIds
      budget: $budget
      dietaryRestrictionExternalIds: $dietaryRestrictionIds
      page: $page
      brandId: $brandId
      brandIds: $brandIds
      priceKeys: $priceKeys
      color: $color
      size: $size
      perPage: $perPage
      sortBy: $sortBy
      searchQuery: $searchQuery
      productId: $productId
      skipAggregations: $skipAggregations
      skipWarehouse: $skipWarehouse
      storeUpcharge: $storeUpcharge
      withSwag: $withSwag
      designedStoreIds: $designedStoreIds
      menuId: $menuId
      preFilterProductIds: $preFilterProductIds
      storeUpdatedAt: $storeUpdatedAt
      excludeOnlyBundleComponentItems: $excludeOnlyBundleComponentItems
      limit: $limit
      globalZone: $globalZone
      withOutOfStock: $withOutOfStock
      showVariantsAsProducts: $showVariantsAsProducts
      productionDays: $productionDays
      shippedFromStadium: $shippedFromStadium
      noMinQuantity: $noMinQuantity
      bulkProducts: $bulkProducts
      ecoFriendly: $ecoFriendly
      bulkAvailable: $bulkAvailable
      menuItemId: $menuItemId
      intent: $intent
      type: $type
      hasTierPricing: $hasTierPricing
      sustainable: $sustainable
      optimizedSearch: $optimizedSearch
      coreOnDemand: $coreOnDemand
      additionalOnDemand: $additionalOnDemand
      printTypes: $printTypes
      excludeByoProducts: $excludeByoProducts
      excludeTierPricing: $excludeTierPricing
      currentStoreId: $currentStoreId
      includeNonColorProducts: $includeNonColorProducts
      designer: $designer
      menuIdentifier: $menuIdentifier
    ) {
      total
      products {
        ...ProductSearchBasicDetails
      }
      aggregations
    }
  }
  ${PRODUCT_SEARCH_BASICS_DETAILS}
`;
